import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

function getHeaders2() {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getsuperAdminProfile = async (id) => {
  // getHeaders());
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/superadmin-profile/${id}/`,
    getHeaders()
  );
  return response;
};
